export enum Translation {
  Auto = 'auto',
  Manual = 'manual',
  None = 'none',
}
